import careersTypes from '../types/careers';
import paymentTypes from "../types/payment";

const initialStore = {
    jobList: [],
    job: null,
    modalOpen: false,
    modalAgentOpen: false,
    modalSuccessOpen: false,
    formJobPosition: '',
    isLoading: false,
};

const careersStore = (state = initialStore, action) => {
    switch (action.type) {
        case careersTypes.SET_JOB_LIST:
            return {
                ...state,
                jobList: action.array,
            };
        case careersTypes.SET_JOB:
            return {
                ...state,
                job: action.object,
            };
        case careersTypes.SET_MODAL_OPEN:
            return {
                ...state,
                modalOpen: action.boolean,
            };
        case careersTypes.SET_MODAL_AGENT_OPEN:
            return {
                ...state,
                modalAgentOpen: action.boolean,
            };
        case careersTypes.SET_MODAL_SUCCESS_OPEN:
            return {
                ...state,
                modalSuccessOpen: action.boolean,
            };
        case careersTypes.SET_FORM_JOB_POSITION:
            return {
                ...state,
                formJobPosition: action.text,
            };
        case careersTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.boolean,
            };
        default:
            return state;
    }
};

export default careersStore;
